/**
 * Sets a cookie with the specified name, value, and expiration days.
 *
 * @param {string} name - The name of the cookie.
 * @param {string} value - The value of the cookie.
 * @param {number} days - The number of days until the cookie expires.
 */
function setCookie(name, value, days) {
	const expirationDate = new Date();
	expirationDate.setDate(expirationDate.getDate() + days);
	document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
}

/**
 * Checks if a cookie with the specified name exists.
 *
 * @param {string} name - The name of the cookie to check.
 * @returns {boolean} - Returns true if the cookie exists, false otherwise.
 */
function checkCookie(name) {
	return document.cookie.includes(`${name}=true`);
}

export { setCookie, checkCookie };
